var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.multipage === true ? 'multi-page':'single-page', 'not-menu-page', 'home-page']},[_c('a-row',{staticClass:"count-info",attrs:{"gutter":8}},[_c('a-col',{staticClass:"visit-count-wrapper",attrs:{"span":24}},[_c('weather',{ref:"weather"})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42221316","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/HomePage.vue
// module id = null
// module chunks = 